class taxAccountDetailCtrl {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $location, $state, $stateParams) {
        $scope.dictData = {}
        $scope.statusList0 = [
            {
                id: '',
                text: '全部',
            },
            {
                id: 0,
                text: '未启用',
            },
            {
                id: 1,
                text: '启用',
            },
        ]
        httpRequest.get_dictByTypeArr('["certificate_type","drawer_active_status","identity_type_tax_account","drawer_channel_type","qpt_login_type","yes_no_flag","rollticket_status","ivat_drawer_channel_type", "drawer_business_scope"]').then((res) => {
            $scope.dictData = res.data.value
        })

        function queryList() {
            httpRequest.post_ovatTax4Drawerget({ drawerId: $stateParams.drawerId }).then((res) => {
                $scope.formObj = res.data.value
            })
            httpRequest.post_ovatTax4DrawerqueryManagementScope($stateParams.drawerId).then((res) => {
                $scope.formData = res.data.value
            })
        }
        queryList()

        $scope.cancel = function () {
            $state.go('system.basedata.taxAccount.list')
        }
    }
}

taxAccountDetailCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$location', '$state', '$stateParams']
export default taxAccountDetailCtrl



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxAccount/detail.js